import type { EquipmentStatus } from '../../types';
import type { FabToolDetail } from '../FabProcessTool/types';
import { normalizeFabToolStatus } from '../FabProcessTool/types';

export type Awp300Status = EquipmentStatus | 'running' | 'idle' | 'warning' | 'error' | 'offline';

/** Reference AWP-300 footprint — 1800 × 1750 × 2400 mm. */
export const AWP_300_DEFAULTS = {
  width: 1.8,
  depth: 1.75,
  height: 2.4,
} as const;

export type Awp300Props = {
  id?: string;
  width?: number;
  depth?: number;
  height?: number;
  ports?: number;
  status?: Awp300Status;
  occupiedPorts?: number[];
  portFractions?: readonly number[];
  detail?: FabToolDetail;
  autoDetail?: boolean;
  opacity?: number;
  position?: [number, number, number];
  rotation?: [number, number, number];
  onSelect?: () => void;
};

export function normalizeAwp300Status(status?: Awp300Status): EquipmentStatus {
  return normalizeFabToolStatus(status);
}

export function clampAwp300PortCount(ports?: number): number {
  return Math.max(1, Math.min(4, Math.round(ports ?? 2)));
}

/** Detect AWP-300 from layout custom properties. */
export function isAwp300Equipment(customProperties?: Record<string, unknown>): boolean {
  const raw = String(
    customProperties?.equipmentModel ??
      customProperties?.equipmentType ??
      customProperties?.model ??
      ''
  ).toUpperCase();
  return raw.includes('AWP-300') || raw.includes('AWP300') || raw === 'AWP' || /^AWP[-\s]?300/.test(raw);
}
